import urlQueryParts from './urlQueryParts';
import { setting } from '@/setting';

const API_BASE_URL = setting.apiHostNewWidget || '';
const API_VERSION = 'v2';
const API_URL = `${API_BASE_URL}/${API_VERSION}/`;
const ACCOUNT = API_URL + 'account';
const AUTH = API_URL + 'auth';
const DATA = API_URL + 'data';
const LOG = API_URL + 'Log';
const ORDER = API_URL + 'order';

export const getProfileAPI = (data) => ACCOUNT + '/me' + urlQueryParts(data);
export const getBalanceAPI = (data) =>
  ACCOUNT + '/me/balance' + urlQueryParts(data);
export const changeAvatarAPI = () => ACCOUNT + '/me/avatar';
export const editProfileAPI = () => ACCOUNT + '/me/edit';
export const registerAPI = () => ACCOUNT + '/register';
export const useBonusPromoCodeAPI = () => ACCOUNT + '/useBonusPromoCode';
export const sendAuthenticationLetterAPI = () =>
  ACCOUNT + '/sendAuthenticationLetter';
export const addFilmToFavoriteAPI = () => ACCOUNT + '/addFilmToFavorite';
export const deleteFilmFromFavoriteAPI = () =>
  ACCOUNT + '/deleteFilmFromFavorite';

export const signInAPI = () => AUTH + '/signin';
export const signInTokenAPI = () => AUTH + '/signin/token';
export const sendSMSCodeAPI = () => AUTH + '/signin/send-sms-code';
export const signInAndRegisterFromSMSAPI = () => AUTH + '/signin-register/sms';
export const signInSMSPhoneAPI = () => AUTH + '/signin/sms';
export const captchaAPI = () => AUTH + '/captcha';

export const getTheatreAPI = (data) =>
  DATA + '/theatreInfo' + urlQueryParts(data);
export const getNotificationsAPI = (data) =>
  DATA + '/notifications' + urlQueryParts(data);
export const getCitiesAPI = () => DATA + '/cities';
export const getCitiesWithTheatresAPI = (data) =>
  DATA + '/citiesWithTheatres' + urlQueryParts(data);
export const getTheatresByCityAPI = (data) =>
  DATA + '/theatresByCity' + urlQueryParts(data);
export const getScheduleAPI = (data) =>
  DATA + '/schedule' + urlQueryParts(data);
export const getScheduleByDateAPI = () => DATA + '/scheduleByDate';
export const getFilmWthScheduleAPI = (data) =>
  DATA + '/filmWithSchedule' + urlQueryParts(data);
export const getSoonAPI = (data) => DATA + '/soon' + urlQueryParts(data);
export const getSoonByFilmAPI = () => DATA + '/soonByFilm';
export const getFilmsAPI = () => DATA + '/films';
export const getFilmsBasicAPI = (data) =>
  DATA + '/filmBasic' + urlQueryParts(data);
export const getSessionPricesAPI = (data) =>
  DATA + '/sessionPrices' + urlQueryParts(data);
export const getHallStatusAPI = (data) =>
  DATA + '/hallStatus' + urlQueryParts(data);
export const getBarAPI = (data) => DATA + '/bar/menu' + urlQueryParts(data);
export const getTheatrePaymentInfoAPI = (data) =>
  DATA + '/theatrePaymentInfo' + urlQueryParts(data);
export const getPrivacyDocumentsAPI = (data) => DATA + '/getPrivacyDocuments' + urlQueryParts(data);

export const getUserSessionAPI = () => LOG + '/getUserSession';
export const IncreaseUserSessionAPI = () => LOG + '/IncreaseUserSession';
export const barLogAPI = () => LOG + '/BarChange';
export const movieLogAPI = () => LOG + '/MovieChange';
export const pageChangeLogAPI = () => LOG + '/PageChange';

export const getHistoryAPI = (data) => ORDER + '/history' + urlQueryParts(data);
export const getProcessingResultAPI = (data) =>
  ORDER + '/processing/result' + urlQueryParts(data);
export const getResultPayment = (data) => ORDER + '/processing/ResultByPayment' + urlQueryParts(data);
export const reserveBarAPI = () => ORDER + '/processing/reserve/bar';
export const reserveTicketAPI = () => ORDER + '/processing/reserve/tickets';
export const useDiscountPromoCodeAPI = () =>
  ORDER + '/processing/useDiscountPromoCode';
export const submitOrderAPI = () => ORDER + '/processing/submitOrder';
export const refundAPI = (data) =>
  ORDER + '/processing/refund' + urlQueryParts(data);
export const privacyPolicyAPI = () => ORDER + '/processing/PrivacyPolicy';

export const ownedGiftCardsAPI = data => ORDER + '/GiftCards/Owned' + urlQueryParts(data);
export const bindGiftCardAPI = number => ORDER + '/GiftCards/' + encodeURIComponent(number) + '/Bind';
